module.exports = __webpack_public_path__ + "img/live-chat-mp4-v2-img.0ab58122.svg";